<lib-dlg [titulo]="ficha?.despesa?.codigo + ' - ' + ficha?.despesa?.nome?.toUpperCase()" nome="saldoFichaDespesa" [visualizar]="visualizar" (onHide)="onHide()"
  styleClassHeader="text-white bg-info">
  <!-- <div class="d-flex justify-content-end align-items-center pt-2 pb-2 pr-3 bg-info text-white">
    <span style="font-size: 16px;"><b>{{ficha?.numero}}</b> - {{ficha?.despesa?.nome?.toUpperCase()}}</span>
  </div> -->
  <ul class="list-group list-group-flush">
    <li class="list-group-item font-weight-bold">
      Dotação
      <span class="float-right">{{saldoFixa?.dotacao | number:'1.2-2'}}</span>
    </li>
    <li class="list-group-item font-weight-bold">
      Reservado
      <span class="float-right">{{saldoFixa?.reservado | number:'1.2-2'}}</span>
    </li>
    <li class="list-group-item font-weight-bold">
      Comprado
      <span class="float-right">{{saldoFixa?.comprado | number:'1.2-2'}}</span>
    </li>
    <li class="list-group-item font-weight-bold">
      Empenhado
      <span class="float-right">{{saldoFixa?.empenhado | number:'1.2-2'}}</span>
    </li>
    <li class="list-group-item font-weight-bold">
      Liquidado
      <span class="float-right">{{saldoFixa?.liquidado | number:'1.2-2'}}</span>
    </li>
    <li class="list-group-item font-weight-bold">
      Pago
      <span class="float-right">{{saldoFixa?.pago | number:'1.2-2'}}</span>
    </li>
  </ul>
</lib-dlg>